import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { teamData, socialMedia } from '../data/mock';
import { Trophy, Calendar, MapPin } from 'lucide-react';

const championships = [
  {
    id: 1,
    name: "Campionato Italiano Prestige MX2",
    description: "Il campionato italiano di riferimento per la categoria MX2",
    logo: "/media/a6x4kuvn_81_20250221123045_thumbnail.png",
    category: "Nazionale"
  },
  {
    id: 2,
    name: "Campionato Italiano Junior",
    description: "Competizione dedicata ai giovani talenti italiani",
    logo: "/media/wqphbp4q_FMI.png",
    category: "Nazionale"
  },
  {
    id: 3,
    name: "Internazionali d'Italia Motocross",
    description: "Eventi internazionali di alto livello sul territorio italiano",
    logo: "/media/8fgwzwgb_INTERNAZIONALI.png",
    category: "Internazionale"
  },
  {
    id: 4,
    name: "Campionato Europeo EMX125",
    description: "Categoria europea dedicata ai piloti 125cc, trampolino di lancio per il mondiale",
    logo: "/media/gp07b93m_EMX125.png",
    category: "Europeo"
  },
  {
    id: 5,
    name: "Campionato Europeo EMX250",
    description: "Categoria europea di alto livello per piloti 250cc",
    logo: "/media/ndvpngtw_Screenshot-2026-04-09-alle-20.23.05.png",
    category: "Europeo"
  },
  {
    id: 6,
    name: "Mondiale MX2",
    description: "Il massimo livello del motocross mondiale",
    logo: "/media/i5k0ifil_mx2-logo-png_seeklogo-516358.png",
    category: "Mondiale"
  }
];

const Campionati = () => {
  return (
    <div className="bg-black min-h-screen relative">
      {/* Checkered Flag Background */}
      <div 
        className="fixed inset-0 opacity-5 pointer-events-none z-0"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-rule='evenodd'%3E%3Crect width='30' height='30'/%3E%3Crect x='30' y='30' width='30' height='30'/%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: '60px 60px'
        }}
      />
      
      <div className="relative z-10">
        <Header logo={teamData.logo} />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-12">
            <h1 className="text-5xl md:text-7xl font-black text-white mb-6">
              I Nostri <span className="text-cyan-400">Campionati</span>
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-cyan-500 to-yellow-400 mx-auto mb-8"></div>
            <p className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto">
              Competizioni Nazionali, Internazionali, Europee e Mondiali
            </p>
          </div>
        </div>
      </section>

      {/* Championships Grid */}
      <section className="py-20 bg-black">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {championships.map((championship) => (
              <div
                key={championship.id}
                className="group bg-gradient-to-br from-gray-900 to-gray-800 p-8 rounded-2xl border border-gray-700 hover:border-cyan-500/50 transition-all duration-300 hover:transform hover:-translate-y-2"
              >
                <div className="flex items-start gap-6">
                  <div className="bg-white w-20 h-20 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300 shadow-lg overflow-hidden p-2">
                    {(championship.logo.startsWith('http') || championship.logo.startsWith('/')) ? (
                      <img loading="lazy" decoding="async" 
                        src={championship.logo} 
                        alt={championship.name}
                        className="w-full h-full object-contain"
                      />
                    ) : (
                      <span className="text-4xl text-black">{championship.logo}</span>
                    )}
                  </div>
                  <div className="flex-1">
                    <span className="inline-block px-3 py-1 bg-yellow-500 text-black text-xs font-bold rounded-full mb-3 uppercase">
                      {championship.category}
                    </span>
                    <h3 className="text-2xl font-bold text-white mb-3">
                      {championship.name}
                    </h3>
                    <p className="text-gray-400 leading-relaxed">
                      {championship.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Info Section */}
          <div className="mt-20 max-w-4xl mx-auto text-center">
            <div className="bg-white/10 backdrop-blur-sm p-10 rounded-3xl border border-gray-700/50">
              <div className="bg-white rounded-2xl p-6 inline-block mb-6">
                <img loading="lazy" decoding="async" 
                  src="/media/fe8ny6i0_Screenshot-2026-04-05-alle-20.23.13.png"
                  alt="Seven Motorsport Logo"
                  className="w-48 h-auto"
                />
              </div>
              <h3 className="text-3xl font-bold text-white mb-4">
                Un Percorso di Eccellenza
              </h3>
              <p className="text-xl text-gray-400 leading-relaxed">
                Il Team Seven Motorsport compete ai massimi livelli in diverse categorie, 
                dai campionati nazionali fino al mondiale MX2, fornendo ai nostri piloti 
                l'esperienza necessaria per crescere e raggiungere il successo internazionale.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer socialMedia={socialMedia} teamName={teamData.name} logo={teamData.logo} />
      </div>
    </div>
  );
};

export default Campionati;
